import React from 'react';
import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Fi from 'react-icons/fi';


const Action = ({ data }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id={`tooltip-top`}>Detil</Tooltip>}
    >
      <Link
        className="btn btn-light px-2"
        role="button"
        to={`/quotation/${data?.id}`}
      >
        <Fi.FiArrowRight />
      </Link>
    </OverlayTrigger>
  );
}

export default Action;
